import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

const buttonColor = {
  primary: {
    background: uiToken.color.button.default,
    text: uiToken.color.text.primary,
    hover: uiToken.color.lightButton.hover,
  },
  secondary: {
    background: uiToken.color.lightButton.default,
    text: uiToken.color.text.dark,
    hover: uiToken.color.lightButton.hover,
  },
};

export const Root = styled.button<{
  buttonType: 'primary' | 'secondary';
  isLoading: boolean;
}>`
  background-color: ${({ buttonType }) => buttonColor[buttonType].background};
  color: ${({ buttonType }) => buttonColor[buttonType].text};
  align-items: center;
  box-sizing: border-box;
  border: 1px solid transparent;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 13px 16px;
  border-radius: 12px;
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  appearance: none;
  cursor: ${({ isLoading }) => (isLoading ? 'default' : 'pointer')};
  pointer-events: ${({ isLoading }) => (isLoading ? 'none' : 'auto')};
  transition-duration: 0.2s;
  transition-property: background-color, color;
  transition-timing-function: ease-in-out;

  &:disabled {
    background-color: ${uiToken.color.lightButton.disabled};
    color: ${uiToken.color.lightButton.text.disabled};
    cursor: not-allowed;
  }

  &:hover {
    background-color: ${({ buttonType }) => buttonColor[buttonType].hover};
  }

  &:disabled:hover {
    background-color: ${uiToken.color.lightButton.disabled};
  }

  &:focus {
    outline: none;
  }

  &:focus-visible:not(:disabled) {
    outline: 2px solid ${uiToken.color.border.glassActive};
    outline-offset: 2px;
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  padding: 4px;
  color: ${uiToken.color.text.primary};
  align-items: center;
  justify-content: center;
`;
